/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg id="Group_2312" data-name="Group 2312" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 24 24">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_251" data-name="Rectangle 251" width="100%" height="100%" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </clipPath>
  </defs>
  <g id="Group_2311" data-name="Group 2311">
    <g id="Group_2310" data-name="Group 2310" clip-path="url(#clip-path)">
      <path id="Path_1074" data-name="Path 1074" d="M17.3,1.849V21.194l-2.13-1.365L13.3,21.194l-1.854-1.353L9.591,21.194l-.017-.012-.017.012L7.7,19.841,5.849,21.194,3.978,19.829l-2.13,1.365V1.849Z" transform="translate(2.453 0.369)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"/>
    </g>
  </g>
  <line id="Line_101" data-name="Line 101" x2="9" transform="translate(7.5 7.256)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
  <line id="Line_102" data-name="Line 102" x2="9" transform="translate(7.5 11.198)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
  <line id="Line_103" data-name="Line 103" x2="9" transform="translate(7.5 15.14)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
</svg>
`

const InvoiceSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default InvoiceSvg
